/* @flow */

import { type StateColors } from './types';

const label = (texto: string, tipo: StateColors) => (
    `<span class="m-badge m-badge--${tipo} m-badge--wide">${texto}</span>`
);

export default label;
